import { PermissionKey } from '@pt/enums/user'
import i18n from '@/lang'

export const companyTypeOptions = [
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.companyType.band'),
    value: 'E-commerce website/app',
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.companyType.agent'),
    value: 'Agency',
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.companyType.media'),
    value: 'Press',
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.companyType.game'),
    value: 'Games',
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.companyType.app'),
    value: 'Non-Game apps/App',
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.companyType.dev'),
    value: 'Developer',
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.companyType.adv'),
    value: 'Advertiser',
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.companyType.other'),
    value: 'others(traffic partners, ad networks, etc)',
  },
]

// 推广产品类型
export enum ProductType {
  Casual = 'Casual',
  HyperCasual = 'Hyper-Casual',
  MidcoreHardCore = 'Midcore-Hardcore',
  Casino = 'Casino',
  PlaytoEarn = 'Play to Earn',
  Entertainment = 'Entertainment',
  SocialApp = 'Social App',
  Utility = 'Utility',
  Education = 'Education',
  Finance = 'Finance',
  Travel = 'Travel',
  Ecommerce = 'Ecommerce',
  Others = 'Others',
}
export const productTypeOptions = [
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.productType.casual'),
    value: ProductType.Casual,
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.productType.hypercasual'),
    value: ProductType.HyperCasual,
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.productType.mid'),
    value: ProductType.MidcoreHardCore,
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.productType.casino'),
    value: ProductType.Casino,
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.productType.playtoearn'),
    value: ProductType.PlaytoEarn,
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.productType.entertainment'),
    value: ProductType.Entertainment,
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.productType.social'),
    value: ProductType.SocialApp,
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.productType.utility'),
    value: ProductType.Utility,
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.productType.education'),
    value: ProductType.Education,
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.productType.finance'),
    value: ProductType.Finance,
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.productType.travel'),
    value: ProductType.Travel,
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.productType.ecommerce'),
    value: ProductType.Ecommerce,
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.companyType.other'),
    value: ProductType.Others,
  },
]

// 联系方式
export enum ConnectType {
  Wechat = '微信',
  Skype = 'Skype',
  Slack = 'Slack',
  Telegram = 'Telegram',
  Other = 'Other',
}

export const connectTypeOptions = [
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.connectType.wechat'),
    value: ConnectType.Wechat,
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.connectType.skype'),
    value: ConnectType.Skype,
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.connectType.slack'),
    value: ConnectType.Slack,
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.connectType.telegram'),
    value: ConnectType.Telegram,
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.companyType.other'),
    value: ConnectType.Other,
  },
]

// 团队规模
export enum TeamSize {
  T1 = '1',
  T2 = '2-5',
  T3 = '6-10',
  T4 = '11-20',
  T5 = '21-40',
  T6 = '41-60',
  T7 = '60+',
}
export const teamSizeOptions = Object.keys(TeamSize).map((key) => {
  return {
    label: TeamSize[key],
    value: TeamSize[key],
  }
})

// 感兴趣的功能
export enum WillFeature {
  Pl = 'Playable Maker',
  Video = 'Video Editor',
  PlVideo = 'Playable Maker,Video Editor',
}

export const willFeatureOptions = [
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.willFeature.pl'),
    value: WillFeature.Pl,
    scope: 1,
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.willFeature.video'),
    value: WillFeature.Video,
    scope: 2,
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.willFeature.plvideo'),
    value: WillFeature.PlVideo,
    scope: 3,
  },
]

export enum WillVideo {
  CrossOver = '视频片段混剪',
  MLang = '视频多语言制作',
  MtSize = '视频多尺寸制作',
  Ai = '视频Ai消除',
}
export const willVideoOptions = [
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.willVideo.crossover'),
    value: WillVideo.CrossOver,
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.willVideo.mlang'),
    value: WillVideo.MLang,
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.willVideo.mtsize'),
    value: WillVideo.MtSize,
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.willVideo.ai'),
    value: WillVideo.Ai,
  },
]

export const mtgCooperationOptions = [
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.ismtg.yes'),
    value: true,
  },
  {
    label: i18n.t('playTurbo.trial.applyTrial.form.ismtg.no'),
    value: false,
  },
]

// 申请试玩权限
export enum TrialScope {
  Pl = 1,
  Video = 2,
  PlVideo = 3,
}

export const TrialScopePermission = {
  Pl: [PermissionKey.Gm, PermissionKey.Ps, PermissionKey.Insights],
  Video: [
    PermissionKey.Ve,
    PermissionKey.Vrec,
    PermissionKey.VeTpl,
    PermissionKey.AIGC,
  ],
}

// pt注册场景扩展的国家列表icon映射
export const trialCountryIcon = {
  af: '🇦🇫', // 阿富汗
  ax: '🇦🇽', // 奥兰群岛
  al: '🇦🇱', // 阿尔巴尼亚
  dz: '🇩🇿', // 阿尔及利亚
  as: '🇦🇸', // 美属萨摩亚
  ad: '🇦🇩', // 安道尔
  ao: '🇦🇴', // 安哥拉
  ai: '🇦🇮', // 安圭拉
  ag: '🇦🇬', // 安提瓜和巴布达
  ar: '🇦🇷', // 阿根廷
  am: '🇦🇲', // 亚美尼亚
  aw: '🇦🇼', // 阿鲁巴
  au: '🇦🇺', // 澳大利亚
  at: '🇦🇹', // 奥地利
  az: '🇦🇿', // 阿塞拜疆
  bs: '🇧🇸', // 巴哈马
  bh: '🇧🇭', // 巴林
  bd: '🇧🇩', // 孟加拉国
  bb: '🇧🇧', // 巴巴多斯
  by: '🇧🇾', // 白俄罗斯
  be: '🇧🇪', // 比利时
  bz: '🇧🇿', // 伯利兹
  bj: '🇧🇯', // 贝宁
  bm: '🇧🇲', // 百慕大
  bt: '🇧🇹', // 不丹
  bo: '🇧🇴', // 玻利维亚
  ba: '🇧🇦', // 波黑
  bw: '🇧🇼', // 博茨瓦纳
  bv: '🇧🇻', // 布韦岛
  br: '🇧🇷', // 巴西
  bn: '🇧🇳', // 文莱
  bg: '🇧🇬', // 保加利亚
  bf: '🇧🇫', // 布基纳法索
  bi: '🇧🇮', // 布隆迪
  kh: '🇰🇭', // 柬埔寨
  cm: '🇨🇲', // 喀麦隆
  ca: '🇨🇦', // 加拿大
  cv: '🇨🇻', // 佛得角
  ky: '🇰🇾', // 开曼群岛
  cf: '🇨🇫', // 中非共和国
  td: '🇹🇩', // 乍得
  cl: '🇨🇱', // 智利
  cn: '🇨🇳', // 中国
  cx: '🇨🇽', // 圣诞岛
  cc: '🇨🇨', // 科科斯群岛
  co: '🇨🇴', // 哥伦比亚
  km: '🇰🇲', // 科摩罗
  cg: '🇨🇬', // 刚果（布）
  cd: '🇨🇩', // 刚果（金）
  ck: '🇨🇰', // 库克群岛
  cr: '🇨🇷', // 哥斯达黎加
  ci: '🇨🇮', // 科特迪瓦
  hr: '🇭🇷', // 克罗地亚
  cu: '🇨🇺', // 古巴
  cy: '🇨🇾', // 塞浦路斯
  cz: '🇨🇿', // 捷克
  dk: '🇩🇰', // 丹麦
  dj: '🇩🇯', // 吉布提
  dm: '🇩🇲', // 多米尼克
  do: '🇩🇴', // 多米尼加
  ec: '🇪🇨', // 厄瓜多尔
  eg: '🇪🇬', // 埃及
  sv: '🇸🇻', // 萨尔瓦多
  gq: '🇬🇶', // 赤道几内亚
  er: '🇪🇷', // 厄立特里亚
  ee: '🇪🇪', // 爱沙尼亚
  et: '🇪🇹', // 埃塞俄比亚
  fo: '🇫🇴', // 法罗群岛
  fj: '🇫🇯', // 斐济
  fi: '🇫🇮', // 芬兰
  fr: '🇫🇷', // 法国
  gf: '🇬🇫', // 法属圭亚那
  pf: '🇵🇫', // 法属波利尼西亚
  ga: '🇬🇦', // 加蓬
  gm: '🇬🇲', // 冈比亚
  ge: '🇬🇪', // 格鲁吉亚
  de: '🇩🇪', // 德国
  gh: '🇬🇭', // 加纳
  gi: '🇬🇮', // 直布罗陀
  gr: '🇬🇷', // 希腊
  gl: '🇬🇱', // 格陵兰
  gd: '🇬🇩', // 格林纳达
  gp: '🇬🇵', // 瓜德罗普
  gu: '🇬🇺', // 关岛
  gt: '🇬🇹', // 危地马拉
  gg: '🇬🇬', // 根西岛
  gn: '🇬🇳', // 几内亚
  gw: '🇬🇼', // 几内亚比绍
  gy: '🇬🇾', // 圭亚那
  ht: '🇭🇹', // 海地
  hn: '🇭🇳', // 洪都拉斯
  hk: '🇭🇰', // 香港
  hu: '🇭🇺', // 匈牙利
  is: '🇮🇸', // 冰岛
  in: '🇮🇳', // 印度
  id: '🇮🇩', // 印度尼西亚
  ir: '🇮🇷', // 伊朗
  iq: '🇮🇶', // 伊拉克
  ie: '🇮🇪', // 爱尔兰
  im: '🇮🇲', // 马恩岛
  il: '🇮🇱', // 以色列
  it: '🇮🇹', // 意大利
  jm: '🇯🇲', // 牙买加
  jp: '🇯🇵', // 日本
  je: '🇯🇪', // 泽西岛
  jo: '🇯🇴', // 约旦
  kz: '🇰🇿', // 哈萨克斯坦
  ke: '🇰🇪', // 肯尼亚
  ki: '🇰🇮', // 基里巴斯
  kr: '🇰🇷', // 韩国
  kw: '🇰🇼', // 科威特
  kg: '🇰🇬', // 吉尔吉斯斯坦
  la: '🇱🇦', // 老挝
  lv: '🇱🇻', // 拉脱维亚
  lb: '🇱🇧', // 黎巴嫩
  ls: '🇱🇸', // 莱索托
  lr: '🇱🇷', // 利比里亚
  ly: '🇱🇾', // 利比亚
  li: '🇱🇮', // 列支敦士登
  lt: '🇱🇹', // 立陶宛
  lu: '🇱🇺', // 卢森堡
  mo: '🇲🇴', // 澳门
  mk: '🇲🇰', // 北马其顿
  mg: '🇲🇬', // 马达加斯加
  mw: '🇲🇼', // 马拉维
  my: '🇲🇾', // 马来西亚
  mv: '🇲🇻', // 马尔代夫
  ml: '🇲🇱', // 马里
  mt: '🇲🇹', // 马耳他
  mh: '🇲🇭', // 马绍尔群岛
  mq: '🇲🇶', // 马提尼克
  mr: '🇲🇷', // 毛里塔尼亚
  mu: '🇲🇺', // 毛里求斯
  yt: '🇾🇹', // 马约特
  mx: '🇲🇽', // 墨西哥
  mf: '🇲🇫', // 法属圣马丁
  md: '🇲🇩', // 摩尔多瓦
  mc: '🇲🇨', // 摩纳哥
  mn: '🇲🇳', // 蒙古
  me: '🇲🇪', // 黑山
  ms: '🇲🇸', // 蒙特塞拉特
  ma: '🇲🇦', // 摩洛哥
  mz: '🇲🇿', // 莫桑比克
  mm: '🇲🇲', // 缅甸
  na: '🇳🇦', // 纳米比亚
  nr: '🇳🇷', // 瑙鲁
  np: '🇳🇵', // 尼泊尔
  nl: '🇳🇱', // 荷兰
  nc: '🇳🇨', // 新喀里多尼亚
  nz: '🇳🇿', // 新西兰
  ni: '🇳🇮', // 尼加拉瓜
  ne: '🇳🇪', // 尼日尔
  ng: '🇳🇬', // 尼日利亚
  nu: '🇳🇺', // 纽埃
  nf: '🇳🇫', // 诺福克岛
  no: '🇳🇴', // 挪威
  om: '🇴🇲', // 阿曼
  pk: '🇵🇰', // 巴基斯坦
  pw: '🇵🇼', // 帕劳
  ps: '🇵🇸', // 巴勒斯坦
  pa: '🇵🇦', // 巴拿马
  pg: '🇵🇬', // 巴布亚新几内亚
  py: '🇵🇾', // 巴拉圭
  pe: '🇵🇪', // 秘鲁
  ph: '🇵🇭', // 菲律宾
  pn: '🇵🇳', // 皮特凯恩群岛
  pl: '🇵🇱', // 波兰
  pt: '🇵🇹', // 葡萄牙
  pr: '🇵🇷', // 波多黎各
  qa: '🇶🇦', // 卡塔尔
  re: '🇷🇪', // 留尼汪
  ro: '🇷🇴', // 罗马尼亚
  ru: '🇷🇺', // 俄罗斯
  rw: '🇷🇼', // 卢旺达
  sh: '🇸🇭', // 圣赫勒拿
  kn: '🇰🇳', // 圣基茨和尼维斯
  lc: '🇱🇨', // 圣卢西亚
  vc: '🇻🇨', // 圣文森特和格林纳丁斯
  ws: '🇼🇸', // 萨摩亚
  sm: '🇸🇲', // 圣马力诺
  st: '🇸🇹', // 圣多美和普林西比
  sa: '🇸🇦', // 沙特阿拉伯
  sn: '🇸🇳', // 塞内加尔
  rs: '🇷🇸', // 塞尔维亚
  sc: '🇸🇨', // 塞舌尔
  sl: '🇸🇱', // 塞拉利昂
  sg: '🇸🇬', // 新加坡
  sk: '🇸🇰', // 斯洛伐克
  si: '🇸🇮', // 斯洛文尼亚
  sb: '🇸🇧', // 所罗门群岛
  so: '🇸🇴', // 索马里
  za: '🇿🇦', // 南非
  es: '🇪🇸', // 西班牙
  lk: '🇱🇰', // 斯里兰卡
  sd: '🇸🇩', // 苏丹
  sr: '🇸🇷', // 苏里南
  sz: '🇸🇿', // 斯威士兰
  se: '🇸🇪', // 瑞典
  ch: '🇨🇭', // 瑞士
  sy: '🇸🇾', // 叙利亚
  tw: '🇹🇼', // 台湾
  tj: '🇹🇯', // 塔吉克斯坦
  th: '🇹🇭', // 泰国
  tl: '🇹🇱', // 东帝汶
  tg: '🇹🇬', // 多哥
  tk: '🇹🇰', // 托克劳
  to: '🇹🇴', // 汤加
  tt: '🇹🇹', // 特立尼达和多巴哥
  tn: '🇹🇳', // 突尼斯
  tr: '🇹🇷', // 土耳其
  tm: '🇹🇲', // 土库曼斯坦
  tc: '🇹🇨', // 特克斯和凯科斯群岛
  tv: '🇹🇻', // 图瓦卢
  ug: '🇺🇬', // 乌干达
  ua: '🇺🇦', // 乌克兰
  ae: '🇦🇪', // 阿联酋
  us: '🇺🇸', // 美国
  uy: '🇺🇾', // 乌拉圭
  uz: '🇺🇿', // 乌兹别克斯坦
  ve: '🇻🇪', // 委内瑞拉
  vn: '🇻🇳', // 越南
  vi: '🇻🇮', // 美属维尔京群岛
  vg: '🇻🇬', // 英属维尔京群岛
  wf: '🇼🇫', // 瓦利斯和富图纳
  eh: '🇪🇭', // 西撒哈拉
  ye: '🇾🇪', // 也门
  zm: '🇿🇲', // 赞比亚
  zw: '🇿🇼', // 津巴布韦
  ss: '🇸🇸', // 南苏丹
  tz: '🇹🇿', // 坦桑尼亚
  cw: '🇨🇼', // 库拉索
  va: '🇻🇦', // 梵蒂冈
  bq: '🇧🇶', // 荷属加勒比区
  pm: '🇵🇲', // 圣皮埃尔和密克隆
  bl: '🇧🇱', // 圣巴泰勒米
  kp: '🇰🇵', // 朝鲜
  aq: '🇦🇶', // 南极洲
  fk: '🇫🇰', // 福克兰群岛
  fm: '🇫🇲', // 密克罗尼西亚
  gs: '🇬🇸', // 南乔治亚和南桑威奇群岛
  hm: '🇭🇲', // 赫德岛和麦克唐纳群岛
  io: '🇮🇴', // 英属印度洋领地
  mp: '🇲🇵', // 北马里亚纳群岛
  sj: '🇸🇯', // 斯瓦尔巴和扬马延
  sx: '🇸🇽', // 荷属圣马丁
  tf: '🇹🇫', // 法属南部领地
  um: '🇺🇲', // 美国本土外小岛屿
  vu: '🇻🇺', // 瓦努阿图
  uk: '🇬🇧', // 英国
}
